/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as ts from 'typescript';

import {CompilerHost, CompilerOptions, Program} from './api';

export {createCompilerHost} from './compiler_host';
export {createProgram} from './program';
